import {
    areMustReadMessagesEnabled,
    queryMustReadMessagesIfNeeded,
} from '@shared/must-read-messages';
import { logger } from '@luna/logger';

export async function initMustReadMessages(): Promise<void> {
    if (!areMustReadMessagesEnabled()) {
        return;
    }

    try {
        await queryMustReadMessagesIfNeeded();
    } catch (error) {
        logger.error('Querying must read messages failed', error);
    }
}
